<sp-layout-builder type="page-builder-context-menu"></sp-layout-builder>

<h2 class="components-tab-title">Components</h2>

<div class="tabs"><div role="tablist" class="tab-selectors tab-selectors--secondary"><span role="tab" class="tab-selector tab-selector--first" tabindex="0"><label for="tab_-2031009511964176168"><input class="tab-selector-radio" type="radio" checked="checked" title="Blank" name="tab_group_18688" value="tab_-2031009511964176168" data-behaviour="tabstate" aria-controls="tab_-2031009511964176168_content" id="tab_-2031009511964176168" /><span class="tab-label"><div class="tab-text">Blank</div></span></label></span><span role="tab" class="tab-selector tab-selector--last" tabindex="0"><label for="tab_-1277658115730973966"><input class="tab-selector-radio" type="radio" title="Shared" name="tab_group_18688" value="tab_-1277658115730973966" data-behaviour="tabstate" aria-controls="tab_-1277658115730973966_content" id="tab_-1277658115730973966" /><span class="tab-label"><div class="tab-text">Shared</div></span></label></span></div><div class="tab-content-container"><div class="tab-content" role="tabpanel" id="tab_-2031009511964176168_content"><fieldset id="blank-components_fieldset" class="fieldset component-templates"><legend>New Components</legend><dl id="blank-components_fieldset_content">      {{#templates}}
        <div class="draggable" data-template-id="{{ id }}" class="{{ id }}">
          <div class="template-container icon-{{ icon_name }}-color" title="{{ name }}" >
            <svg title="{{ name }}" class="icon icon-{{icon_name}}-color"><use class="icon-{{icon_name}}-color" xlink:href='{{ iconSpriteUrl }}#icon-{{icon_name}}-color'></use></svg>
            <p>{{ name }}</p>
          </div>
        </div>
      {{/templates}}
</dl></fieldset></div><div class="tab-content" role="tabpanel" id="tab_-1277658115730973966_content" style="display: none;"><fieldset id="shared-components_fieldset" class="fieldset shared-components"><legend>Shared Components</legend><dl id="shared-components_fieldset_content">
      <div id="shared-components-search-and-filter" class="search-and-filter-bar">
        <input type="text" id="sharedSearch" placeholder="Search by title or ID" />
        <section class="dropdown down right">
          <span class="btn action dropdown-button filters-button">
            <span class="button-text">Filters</span>
          </span>
          <nav class="dropdown-menu" data-close-menu="false">
            <div class="dropdown-content dropdown-action-panel">

              <ul>
                <li class="group-settings-option unique">
                  <span class="label">Type</span>
                  {{sp_select_tag "type" choices=typeItems selected=""}}
                </li>
              </ul>

              <ul>
                <li class="group-settings-option unique">
                  <span class="label">Behavior</span>
                  {{sp_select_tag "behavior" choices=behaviorItems selected=""}}
                </li>
              </ul>

              <ul>
                <li class="group-settings-option unique">
                  <span class="label">Label</span>
                  {{sp_select_tag "label" choices=labelItems selected="" searchable=true}}
                </li>
              </ul>

              <button name="button" type="submit" class="action-button confirm">Done</button>
              <button name="button" type="submit" class="action-button reset">Reset Filters</button>

            </div>
          </nav>
        </section>
      </div>

      <div id="shared-components-sort">
        <dropdown class="dropdown"><span tabindex="0" role="button" class="dropdown-button"><span class="button-text">Sort</span></span><dropdown-menu class="dropdown-menu with-icons"><div class="dropdown-content-margin"><span data-sort="date-created" class="dropdown-item"><span class="dropdown-item-icon"><sp-icon name="check-alt-color" size="small"></sp-icon></span>Date Created</span><span data-sort="recently-modified" class="dropdown-item">Recently Modified</span><span data-sort="alphabetical" class="dropdown-item">Alphabetical</span><span data-sort="most-used" class="dropdown-item">Most Used</span></div></dropdown-menu></dropdown>
      </div>

      <div id="searchMessage" class="searchMessage">No components matched your search</div>
      {{#shared}}
        <div class="draggable" draggable="true" data-component-id="{{ id }}" data-search-lookup="{{ id }}">
          <div class="template-container icon-{{ template }}">
           <svg title="{{ name }}" class="{{role}} icon icon-{{icon_name}}"><use class="icon-{{icon_name}}-color" xlink:href='{{ iconSpriteUrl }}#icon-{{icon_name}}-color'></use></svg>
            <p class="name">
              {{ name }}
              <span class="details">
                <span class="id">&#35;{{ id }} &bull; </span>
                <span class="template">{{ template_name }} &bull; </span>
                <span class="updated-at">Edited {{ updated_at }}</span>
              </span>
            </p>
            <svg title="View Details" class="icon icon-info shared-component-info">
              <use class="icon-info" xlink:href='{{ iconSpriteUrl }}#icon-info'></use>
            </svg>
          </div>
        </div>
      {{/shared}}

</dl></fieldset></div></div></div>
